module.exports = __webpack_public_path__ + "img/cattunnel19.92acb291.jpg";